var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutbidedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_548_22063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 6V8.5M8 10V10.0067",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33411 12.6664H12.6674C12.885 12.6648 13.0988 12.6101 13.2904 12.5069C13.4819 12.4038 13.6453 12.2553 13.7663 12.0745C13.8872 11.8937 13.9621 11.686 13.9844 11.4696C14.0067 11.2532 13.9757 11.0347 13.8941 10.833L9.16078 2.66635C9.04547 2.45795 8.87645 2.28424 8.67128 2.16328C8.46611 2.04231 8.23228 1.97852 7.99411 1.97852C7.75594 1.97852 7.52211 2.04231 7.31694 2.16328C7.11177 2.28424 6.94275 2.45795 6.82744 2.66635L2.09411 10.833C2.01407 11.0301 1.98233 11.2434 2.00154 11.4552C2.02076 11.667 2.09036 11.8712 2.20455 12.0506C2.31873 12.2301 2.47418 12.3796 2.65793 12.4867C2.84167 12.5938 3.04837 12.6554 3.26078 12.6664",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_548_22063"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutbidedIcon);
export default __webpack_public_path__ + "static/media/outbidedIcon.6cee40b31a39999ad60b2b3f4332a41b.svg";
export { ForwardRef as ReactComponent };